//import axios to make request
import axios from "axios";

// get all distributors
export async function getDistributors({ commit }) {
  try {
    const { data } = await axios.get("/distributors");

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// get all users by distributor
export async function getUsersByDistributor({ commit }, payload) {
  try {
    const { data } = await axios.get("/user/distributor", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// add user
export async function addUser({ commit }, payload) {
  try {
    const { data } = await axios.post("/user/add", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// update user
export async function updateUser({ commit }, payload) {
  try {
    const { data } = await axios.put("/user/update", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// verify if already exist user with the same email
export async function getEmailVerification({ commit }, payload) {
  try {
    const { data } = await axios.get("/user/email-verification", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// get user by id
export async function getUser({ commit }, payload) {
  try {
    const { data } = await axios.get("/user/get-user", {
      params: payload,
    });

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// suspend user
export async function suspendUser({ commit }, payload) {
  try {
    const { data } = await axios.post("/user/suspend", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}

// active user
export async function activeUser({ commit }, payload) {
  try {
    const { data } = await axios.post("/user/active", payload);

    if (data.error) {
      throw data;
    }
    return data;
  } catch (e) {
    console.log(e);
    return null;
  }
}
